import React from 'react';
import { ChartSource } from '../types/charts';

interface ChartCardProps {
  source: ChartSource;
  onClick: () => void;
}

const ChartCard: React.FC<ChartCardProps> = ({ source, onClick }) => {
  const Icon = source.logo;
  const isBillboardChart = source.id.startsWith('billboard');

  return (
    <div
      onClick={isBillboardChart ? onClick : undefined}
      className={`group relative overflow-hidden glass-card rounded-2xl transition-all duration-300 ${
        isBillboardChart
          ? 'cursor-pointer hover-lift hover:border-indigo-200/50 dark:hover:border-indigo-800/50'
          : 'opacity-75'
      }`}
    >
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <div className={`p-3.5 rounded-xl ${
            isBillboardChart 
              ? 'bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-indigo-900/30 dark:to-purple-900/30 group-hover:from-indigo-100 group-hover:to-purple-100 dark:group-hover:from-indigo-900/40 dark:group-hover:to-purple-900/40' 
              : 'bg-gray-100 dark:bg-gray-800'
          } transition-colors duration-300`}>
            <Icon className={`w-8 h-8 ${
              isBillboardChart 
                ? 'text-indigo-600 dark:text-indigo-400' 
                : 'text-gray-400 dark:text-gray-500'
            }`} />
          </div>
          {isBillboardChart ? (
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400 group-hover:bg-indigo-100 dark:group-hover:bg-indigo-900/40 transition-colors duration-300">
              View Chart
            </span>
          ) : (
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
              Coming Soon
            </span>
          )}
        </div>
        <h3 className={`text-xl font-semibold mb-3 ${
          isBillboardChart 
            ? 'text-gray-900 dark:text-white' 
            : 'text-gray-600 dark:text-gray-400'
        }`}>
          {source.name}
        </h3>
        <p className="text-gray-500 dark:text-gray-400 line-clamp-2 leading-relaxed">
          {source.description}
        </p>
      </div>
      {isBillboardChart && (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/[0.03] to-purple-600/[0.03] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-indigo-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </>
      )}
    </div>
  );
};

export default ChartCard;